export const sendAccessTokenReqOptions = [
  {
    id: "MAKE_ACCESS_TOKEN_REQUEST_AS",
    values: [
      {
        label: "Query Params",
        value: "query_params",
      },
      {
        label: "Body (json)",
        value: "body",
      },
      {
        label: "x-www-form-urlencoded",
        value: "x-www-form-urlencoded",
      },
    ],
  },
];
const urlEncodeHelperText =
  "If there is any special chars example +&=, in Client Id, Client Secret, Password or Username then this might be required";
export const authroizationCodeFields = [
  {
    id: "NAME",
    title: "Credential name",
    type: "TEXT",
  },
  {
    id: "AUTHORIZE_URL",
    title: "Authorization Url",
    type: "TEXT",
  },
  {
    id: "ACCESS_TOKEN_URL",
    title: "Access Token Url",
    type: "TEXT",
  },
  {
    id: "CLIENT_ID",
    title: "Client Id",
    type: "TEXT",
  },
  {
    id: "CLIENT_SECRET",
    title: "Client Secret",
    type: "TEXT",
  },
  {
    id: "SCOPE",
    title: "Scope",
    type: "TEXT",
  },
  {
    id: "AUTHORIZATION_HEADER_PREFIX",
    title: "Authorization Header Prefix",
    type: "TEXT",
    helperText: "Default for OAuth is Bearer. Used for adding a prefix in Authorization header. Example Bearer + token or MyPrefix + token",
  },
  {
    id: "INCLUDE_SCOPE_IN_ACCESS_TOKEN_REQ",
    title: "Include Scope when requesting an access token",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
  },
  {
    id: "MAKE_ACCESS_TOKEN_REQUEST_AS",
    title: "Make access token request with",
    type: "SELECTLIST",
    helperText:
      "The default is to use query params to send the access token request. Some system requires the payload to be sent as json body, in these cases use the Body (json) option.",
  },
  {
    id: "INCLUDE_STATE",
    title: "Include state",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
  },
  {
    id: "URL_ENCODE",
    title: "URL Encode Request Parameters",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
    helperText: urlEncodeHelperText,
  },
];
export const passwordFields = [
  {
    id: "NAME",
    title: "Credential name",
    type: "TEXT",
  },

  {
    id: "ACCESS_TOKEN_URL",
    title: "Access Token Url",
    type: "TEXT",
  },
  {
    id: "USERNAME",
    title: "Username",
    type: "TEXT",
  },
  {
    id: "PASSWORD",
    title: "Password",
    type: "TEXT",
  },
  {
    id: "CLIENT_ID",
    title: "Client Id",
    type: "TEXT",
  },
  {
    id: "CLIENT_SECRET",
    title: "Client Secret",
    type: "TEXT",
  },
  {
    id: "SCOPE",
    title: "Scope",
    type: "TEXT",
  },
  {
    id: "AUTHORIZATION_HEADER_PREFIX",
    title: "Authorization Header Prefix",
    type: "TEXT",
    helperText: "Default for OAuth is Bearer. Used for adding a prefix in Authorization header. Example Bearer + token or MyPrefix + token",
  },
  {
    id: "INCLUDE_SCOPE_IN_ACCESS_TOKEN_REQ",
    title: "Include Scope when requesting an access token",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
  },
  {
    id: "MAKE_ACCESS_TOKEN_REQUEST_AS",
    title: "Make access token request with",
    type: "SELECTLIST",
    helperText:
      "The default is to use query params to send the access token request. Some system requires the payload to be sent as json body, in these cases use the Body (json) option.",
  },
  {
    id: "INCLUDE_STATE",
    title: "Include state",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
  },
  {
    id: "URL_ENCODE",
    title: "URL Encode Request Parameters",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
    helperText: urlEncodeHelperText,
  },
];

export const clientCredentialsFields = [
  {
    id: "NAME",
    title: "Credential name",
    type: "TEXT",
  },

  {
    id: "ACCESS_TOKEN_URL",
    title: "Access Token Url",
    type: "TEXT",
  },
  {
    id: "CLIENT_ID",
    title: "Client Id",
    type: "TEXT",
  },
  {
    id: "CLIENT_SECRET",
    title: "Client Secret",
    type: "TEXT",
  },
  {
    id: "SCOPE",
    title: "Scope",
    type: "TEXT",
  },
  {
    id: "AUTHORIZATION_HEADER_PREFIX",
    title: "Authorization Header Prefix",
    type: "TEXT",
    helperText: "Default for OAuth is Bearer. Used for adding a prefix in Authorization header. Example Bearer + token or MyPrefix + token",
  },
  {
    id: "INCLUDE_SCOPE_IN_ACCESS_TOKEN_REQ",
    title: "Include Scope when requesting an access token",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
  },
  {
    id: "MAKE_ACCESS_TOKEN_REQUEST_AS",
    title: "Make access token request with",
    type: "SELECTLIST",
    helperText:
      "The default is to use query params to send the access token request. Some system requires the payload to be sent as json body, in these cases use the Body (json) option.",
  },
  {
    id: "INCLUDE_STATE",
    title: "Include state",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
  },
  {
    id: "URL_ENCODE",
    title: "URL Encode Request Parameters",
    checkboxValueLabel: "Yes",
    type: "CHECKBOX",
    helperText: urlEncodeHelperText,
  },
];
export const CODE = "code";
export const PASSWORD = "password";
export const CLIENT_CRED = "client_credentials";

export const TYPE_OPTIONS = [
  { label: "Authorization Code Grant", value: CODE },
  { label: "Resource Owner Password Credentials Grant", value: PASSWORD },
  { label: "Client Credentials Grant", value: CLIENT_CRED },
];
